import { requestKarangoApi } from "../../../core/api/karangoTransport";

// Cree le lien au premier appel, renvoie ensuite toujours le meme tant qu'il
// n'a pas ete regenere explicitement (cf. userShareLinkService.js cote
// backend). Ne jamais logger le retour (contient l'URL avec le token).
export async function getOrCreateOrganizedEventsShareLink() {
  const payload = await requestKarangoApi("/v1/me/share-links/events", {
    method: "POST",
    requiresAuth: true,
  });
  return payload.url;
}

// Remplace le lien existant : l'ancien devient invalide immediatement.
export async function regenerateOrganizedEventsShareLink() {
  const payload = await requestKarangoApi("/v1/me/share-links/events/regenerate", {
    method: "POST",
    requiresAuth: true,
  });
  return payload.url;
}

// Endpoint public, sans authentification : ne jamais passer requiresAuth ni
// optionalAuth ici, le resultat ne doit jamais dependre de qui consulte le
// lien. Le backend renvoie systematiquement 404 pour un token malforme,
// inconnu ou revoque, avec la forme { error: "..." } (pas la forme
// { error: { code, message } } utilisee ailleurs dans l'API) — c'est
// deliberement le cas pour ne jamais laisser deviner lequel des trois cas
// s'est produit. Les appelants doivent donc distinguer sur error.status
// (404), jamais sur error.message/error.code.
export async function getPublicOrganizedEvents(token, { cursor, limit } = {}) {
  const params = new URLSearchParams();
  if (cursor) {
    params.set("cursor", cursor);
  }
  if (limit) {
    params.set("limit", String(limit));
  }
  const query = params.toString();
  const path = `/v1/public/organizer-events/${encodeURIComponent(token)}${query ? `?${query}` : ""}`;

  return requestKarangoApi(path, { method: "GET" });
}
